
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const handleSearchClick = () => {
    window.REACT_APP_NAVIGATE('/search');
  };

  const handleEstimateClick = () => {
    // 査定ページへの遷移処理
    console.log('無料査定ページへ');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景動画 */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="https://videos.pexels.com/video-files/7578555/7578555-uhd_2560_1440_30fps.mp4" type="video/mp4" />
        <source src="https://videos.pexels.com/video-files/3571264/3571264-uhd_2560_1440_30fps.mp4" type="video/mp4" />
      </video>
      
      {/* オーバーレイ */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-left text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            地域とともに、<br />
            あなたの住まいを考える。
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-2xl">
            地元に根ざした視点で、あなたの暮らしに寄り添います。<br />
街を知り、人を知るからこそできる、心地よい住まいのご提案を。
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button size="lg" className="bg-blue-600 hover:bg-blue-700" onClick={handleSearchClick}>
              <i className="ri-search-line mr-2"></i>
              物件を探す
            </Button>
            <Button size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-gray-900" onClick={handleEstimateClick}>
              <i className="ri-calculator-line mr-2"></i>
              無料査定
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
